"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DateParser_1 = require("../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var UserInfo_1 = require("../../user/model/UserInfo");
/**
 * DTO object for a {@link WindowFile WindowFile} containing all needed info.
 * @author OPt
 */


var WindowFileOverviewDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(WindowFileOverviewDTO, _DomainObject_1$Domai);

  /**
   * Creates new instance of WindowFileOverviewDTO.
   */
  function WindowFileOverviewDTO(id, windowId, filename, uploadDate, uploadedBy, note) {
    var _this;

    _classCallCheck(this, WindowFileOverviewDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WindowFileOverviewDTO).call(this));
    _this.id = id;
    _this.windowId = windowId;
    _this.filename = filename;
    _this.uploadDate = uploadDate;
    _this.uploadedBy = uploadedBy;
    _this.note = note;
    return _this;
  }

  return WindowFileOverviewDTO;
}(DomainObject_1.DomainObject);

exports.WindowFileOverviewDTO = WindowFileOverviewDTO;

WindowFileOverviewDTO.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(WindowFileOverviewDTO.name);
  return {
    id: builder.id('id'),
    windowId: builder.str('windowId'),
    filename: builder.str('filename'),
    uploadDate: builder.date('uploadDate', DateParser_1.DateParser.ISO_PATTERN),
    uploadedBy: builder.obj('uploadedBy', UserInfo_1.UserInfo.schema, function (mat) {
      return new UserInfo_1.UserInfo(mat.id, mat.name);
    }),
    note: builder.opt(builder.str('note'))
  };
}();